export default function AnnouncementBar() {
  const items = [
    "Worldwide Shipping",
    "1-Year Warranty",
    "14-Day Returns",
  ];
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-navy-deep text-white/90 text-[11px] py-2.5 px-4 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between gap-6 overline">
        <div className="flex items-center gap-4 sm:gap-6 flex-wrap">
          {items.map((it, i) => (
            <span key={it} className="inline-flex items-center gap-4 sm:gap-6">
              {it}
              {i < items.length - 1 && (
                <span className="text-white/25">·</span>
              )}
            </span>
          ))}
        </div>
        <div className="hidden md:inline-flex items-center gap-2 text-teal-brand">
          <span className="h-1.5 w-1.5 rounded-full bg-teal-brand pulse-dot" />
          Trusted by 10,000+ Customers
        </div>
      </div>
    </div>
  );
}
